import enTranslations from "./en.json";
import nlTranslations from "./nl.json";
import deTranslations from "./de.json";
import frTranslations from "./fr.json";
import esTranslations from "./es.json";

export type SupportedLanguage = "en" | "nl" | "de" | "fr" | "es";

export const SUPPORTED_LANGUAGES: { code: SupportedLanguage; name: string; flag: string }[] = [
	{ code: "en", name: "English", flag: "gb" },
	{ code: "nl", name: "Nederlands", flag: "nl" },
	{ code: "de", name: "Deutsch", flag: "de" },
	{ code: "fr", name: "Français", flag: "fr" },
	{ code: "es", name: "Español", flag: "es" },
];

const translationMap: Record<SupportedLanguage, Record<string, string>> = {
	en: enTranslations,
	nl: nlTranslations,
	de: deTranslations,
	fr: frTranslations,
	es: esTranslations,
};

/**
 * Returns the full translations object for the given language.
 * Falls back to English if the language is not supported.
 */
export function getTranslations(lang: SupportedLanguage): Record<string, string> {
	return translationMap[lang] || translationMap["en"];
}

/**
 * Looks up a translation key in the given translations map.
 * Returns the fallback string (or the key itself) if the key is not found.
 */
export function t(translations: Record<string, string>, key: string, fallback?: string): string {
	return translations[key] ?? fallback ?? key;
}

/**
 * Checks whether a language code is a supported language.
 */
export function isSupportedLanguage(lang: string): lang is SupportedLanguage {
	return Object.keys(translationMap).includes(lang);
}
